import {ModuleWithProviders, NgModule, Optional, SkipSelf} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TorchAPIConfiguration, TorchAPIConfigurationParams} from '../../config/api.configuration';
import {LoggingService} from '../../../app/shared/services/logging.service';

@NgModule({
  imports: [
    CommonModule,
  ],
})
export class TorchPainIndexesModule {
  constructor(@Optional() @SkipSelf() parentModule: TorchPainIndexesModule, private logger: LoggingService) {
    if (parentModule) {
      throw new Error('TorchPainIndexesModule is already loaded. Import in your base TorchBackend only.');
    }

    logger.log('Loaded TorchPainIndexesModule');
  }

  static forRoot(params: TorchAPIConfigurationParams): ModuleWithProviders<unknown> {
    return {
      ngModule: TorchPainIndexesModule,
      providers: [
        {
          provide: TorchAPIConfiguration,
          useValue: params
        },
      ]
    };
  }
}
